<template>
  <!-- https://getbootstrap.com/docs/4.1/examples/sign-in/ - https://getbootstrap.com/docs/4.1/examples/sign-in/ -->
  <div class="text-center authentication-form">
    <form class="form-authentication" @submit.prevent="onSubmit">
      <div v-if="!validEmail">
        <!-- <img class="mb-4" src="../../assets/brand/bootstrap-solid.svg" alt="" width="72" height="72"> -->
        <!-- <img class="mb-4" src="../assets/img/logo/logo-dame-una-mano_imageonly_purple.svg" alt="" width="72" height=""> -->
        <!-- <h1 class="h3 font-weight-normal" style="margin-bottom: 0;">Inscríbete a</h1> -->
        <!-- <h1 class="h3 mb-3 font-weight-normal">Dame Una Mano</h1> -->
        <h3 class="mb-2" style="color: var(--coredarkcolor);">Reset Password</h3>
        <p class="mb-2">Please enter the email address you used to register.</p>

        <label for="inputEmail" class="sr-only">Email</label>
        <input type="email" id="inputEmail" class="form-control" placeholder="Email Address" required autofocus v-model="email">
        <!-- <label for="inputPassword" class="sr-only">Password</label> -->
        <!-- <input type="password" id="inputPassword" class="form-control" placeholder="Contraseña" required v-model="password"> -->
        <!-- <div class="checkbox mb-3">
          <label>
            <input type="checkbox" value="remember-me"> Remember me
          </label>
        </div> -->
        <button class="btn btn-lg btn-primary btn-block" type="submit">Reset Password</button>
        <!-- <p class="mt-5 mb-5 text-muted">&copy; 2017-2018</p> -->
        <!-- <p class="pt-4">¿Ya tienes un perfil? <router-link to="/iniciar-sesion" class="">Iniciar sesión</router-link></p> -->
      </div>
      <div v-if="validEmail">
        <h4>Please check your email for instructions to reset your password!</h4>
      </div>
      <div v-if="validEmail == false">
        <p class="mt-2" style="font-weight: 700;">Sorry, this email is not valid. Please try again.</p>
      </div>

      <p class="pt-4 pb-5"><router-link :to="{ name: 'Login' }">I remember, Login</router-link></p>
      <!-- <p class="pt-4 pb-5 text-muted">¿Preguntas? 350-4775478</p> -->
    </form>
  </div>
</template>

<script>
  // import axios from 'axios';
  import axios from 'axios'; // Don't have to name it axios, can name it anything - Lecture 348

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data () {
      return {
        email: '',
        // password: '',

        validEmail: null,
      }
    },
    methods: {
      onSubmit () {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },1500)

        // axios.post('/password-reset/', {
        // axios.post('/rest-auth/password/reset/', {
        axios.post('/api/password_reset/reset_password/', {
          email: this.email
        })
          .then(res => {
            console.log(res)
            this.validEmail = true
          })
          .catch(error => {
            console.log(error)
            this.validEmail = false
          })
      }
    }
  }
</script>

<style>
  .form-authentication input[type="email"] {
    margin-bottom: 10px;
    /* border-bottom-right-radius: 0; */
    /* border-bottom-left-radius: 0; */
  }
</style>



// WEBPACK FOOTER //
// src/components/password/PasswordResetRequest.vue